var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',_vm._b({attrs:{"small":""}},'v-chip',_vm.$attrs,false),[_vm._v(_vm._s(_vm.company.short_name))])}
var staticRenderFns = []

export { render, staticRenderFns }